import { useGetAllRolesQuery } from "app/services/api/rolesApi";
import { RoleModel } from "app/services/api/types/roles/models/RoleModel";
import { useMemo } from "react";

export function useRolesDropdownOptions() {
  const { data: rolesData, isLoading } = useGetAllRolesQuery(undefined);

  const rolesOptions = useMemo(() => {
    return (
      rolesData?.map((role: RoleModel) => ({
        value: role.id,
        label: role.display_name,
      })) || []
    );
  }, [rolesData]);

  return { rolesOptions, isLoading };
}
